import React from 'react';

function ErrorFragment() {
  return (
    <div>
      <h3 className="u-clr-white">Sorry, we seem to have hit a problem processing your request</h3>
      <p className="u-padding-m-top">
        Please try the link that was shared with you again.
      </p>
    </div>
  );
}

export default ErrorFragment;
